import React, { useState } from 'react'

import { LntModal, LntUploadDragger, LntButton } from '@app/components/base'

import { isFile } from '@app/typeGuards'
import { isEmptyArray, isNull } from '@app/utils'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { UploadFile } from 'antd/es/upload'
import type { FileUploadModalProps } from './types'
import type { ShowUploadListInterface } from 'antd/es/upload/interface'

const showUploadList: ShowUploadListInterface = {
  showRemoveIcon: true,
  showPreviewIcon: false,
  showDownloadIcon: false
}

const FILE_UPLOAD_ERROR_MESSAGE = 'Error loading file, failed to convert to standard file of type "File"'

export const FileUploadModal: React.FC<FileUploadModalProps> = ({ open, title, accept, onCancel, onFileUpload }) => {
  const [fileList, setFileList] = useState<Array<UploadFile<File>>>([])

  const afterClose = (): void => {
    setFileList([])
  }

  const handleDownloadFiles = (): void => {
    const [uploadFile = null] = fileList

    if (!isFile(uploadFile) && !isNull(uploadFile)) throw new Error(FILE_UPLOAD_ERROR_MESSAGE)

    const file: File | null = uploadFile

    onFileUpload?.(file)
  }

  const beforeUpload = (file: UploadFile<File>): boolean => {
    setFileList([file])
    return false
  }

  const handleRemove = (uploadFile: UploadFile<File>): void => {
    setFileList(prev => prev.filter(file => file !== uploadFile))
  }

  return (
    <LntModal
      className={ styles.fileUploadModal }
      open={ open }
      title={ title }
      okText='Загрузить'
      okButtonProps={ { disabled: isEmptyArray(fileList) } }
      afterClose={ afterClose }
      onOk={ handleDownloadFiles }
      onCancel={ onCancel }
    >
      <LntUploadDragger
        className={ styles.draggerWrap }
        accept={ accept }
        fileList={ fileList }
        showUploadList={ showUploadList }
        beforeUpload={ beforeUpload }
        onRemove={ handleRemove }
      >
        <p className={ styles.fileUploadModal__info }>Перетащите файл сюда или нажмите кнопку ниже</p>

        <LntButton
          className={ styles.fileUploadModal__btn }
          type={ BUTTON_TYPE.primary }
          size={ SIZE.small }
        >
          Выбрать файл
        </LntButton>
      </LntUploadDragger>
    </LntModal>
  )
}
